(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kw-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // ── Reading-Progress: auf dem tatsaechlichen Scroller (Horizon: .page-wrapper ab 990px, sonst window) ──
    var bar = document.querySelector('[data-kw-progress]');
    if (bar) {
      var pw = document.querySelector('.page-wrapper');
      var ticking = false;
      function update() {
        var el = (pw && pw.scrollHeight - pw.clientHeight > 4) ? pw : (document.scrollingElement || document.documentElement);
        var max = el.scrollHeight - el.clientHeight;
        bar.style.width = (max > 0 ? (el.scrollTop / max) * 100 : 0) + '%';
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
      }, { capture: true, passive: true });
      update();
    }
    // ── Reveal (robust: IO wo vorhanden, sonst/als Fallback alles sichtbar) ──
    var reveals = document.querySelectorAll('.kw .reveal');
    function revealAll() { reveals.forEach(function (el) { el.classList.add('in'); }); }
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      revealAll();
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -40px 0px' });
      reveals.forEach(function (el) { io.observe(el); });
      setTimeout(revealAll, 1500); // Failsafe, falls IO im Kontext nicht feuert
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-blog-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // ── Reveal der Post-Karten (identisches Muster wie kw-article.liquid):
    // .reveal startet opacity:0 (kw-blog.css) und braucht .in — ohne dieses
    // Script bleiben die Karten der Blog-Uebersicht unsichtbar.
    var reveals = document.querySelectorAll('.kw .reveal');
    function revealAll() { reveals.forEach(function (el) { el.classList.add('in'); }); }
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      revealAll();
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -40px 0px' });
      reveals.forEach(function (el) { io.observe(el); });
      setTimeout(revealAll, 1500); // Failsafe, falls IO im Kontext nicht feuert
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-brands-index"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var input = document.querySelector('input[id^="kwBrandFilter-"]');
    if (!input) return;
    var scope = input.closest('.shopify-section') || document;
    var groups = [].slice.call(scope.querySelectorAll('.letter-group'));
    var noRes = scope.querySelector('[id^="kwBrandNoRes-"]');
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var anyVisible = false;
      groups.forEach(function (g) {
        var items = [].slice.call(g.querySelectorAll('.brand-item'));
        var groupHit = false;
        items.forEach(function (it) {
          var name = (it.getAttribute('data-brand') || '').toLowerCase();
          var hit = name.indexOf(q) !== -1;
          it.style.display = hit ? '' : 'none';
          if (hit) groupHit = true;
        });
        g.style.display = groupHit ? '' : 'none';
        if (groupHit) anyVisible = true;
      });
      if (noRes) noRes.hidden = anyVisible;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-reviews"] && !Shopify.designMode) return;
  try {
    
  class KwReviewsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.rev-track');
      this.bar = this.querySelector('.rev-progress__bar');
      if (!this.track) return;
      this.arrows = this.querySelectorAll('.rev-arrow');
      this.arrows.forEach((btn) => {
        btn.addEventListener('click', () => this.step(btn.dataset.dir === 'next' ? 1 : -1));
      });
      this.track.addEventListener('scroll', () => this.schedule(), { passive: true });
      window.addEventListener('resize', () => this.schedule(), { passive: true });
      this.sync();
      this.setupAutoplay();
    }

    setupAutoplay() {
      const secs = parseFloat(this.dataset.autoplay || '0');
      if (!secs) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.delay = secs * 1000;
      this.paused = false;

      // Pausieren, solange jemand liest oder selbst bedient — sonst springt die Karte
      // unter dem Finger weg. Beruehrung pausiert dauerhaft, das ist die klare Absicht.
      const hold = () => { this.paused = true; };
      const release = () => { this.paused = false; };
      this.addEventListener('mouseenter', hold);
      this.addEventListener('mouseleave', release);
      this.addEventListener('focusin', hold);
      this.addEventListener('focusout', release);
      this.track.addEventListener('pointerdown', () => { this.stopAutoplay(); }, { passive: true });

      // Nur laufen lassen, wenn der Slider ueberhaupt im Bild ist.
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((es) => {
          this.visible = es[0].isIntersecting;
        }, { threshold: 0.35 });
        this.io.observe(this);
      } else {
        this.visible = true;
      }
      document.addEventListener('visibilitychange', () => {
        this.hidden_ = document.hidden;
      });

      this.timer = setInterval(() => {
        if (this.paused || this.hidden_ || this.visible === false) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.track.scrollLeft >= max - 1) {
          this.track.scrollTo({ left: 0, behavior: 'smooth' });   // sanft zurueck an den Anfang
        } else {
          this.step(1);
        }
      }, this.delay);
    }

    stopAutoplay() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
      if (this.io) { this.io.disconnect(); this.io = null; }
    }

    disconnectedCallback() { this.stopAutoplay(); }

    get pageWidth() {
      const card = this.track.querySelector('.quote');
      if (!card) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      // Immer um die Anzahl sichtbarer Karten weiterspringen, nie um eine halbe.
      const per = Math.max(1, Math.round(this.track.clientWidth / (card.offsetWidth + gap)));
      return (card.offsetWidth + gap) * per;
    }

    step(dir) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: dir * this.pageWidth, behavior: reduce ? 'auto' : 'smooth' });
    }

    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
    }

    sync() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const left = this.track.scrollLeft;
      if (this.bar) {
        const visible = max > 0 ? this.track.clientWidth / this.track.scrollWidth : 1;
        const ratio = max > 0 ? left / max : 0;
        this.bar.style.width = Math.max(visible * 100, 8) + '%';
        this.bar.style.transform = 'translateX(' + (ratio * (100 / Math.max(visible * 100, 8) * 100 - 100)) + '%)';
      }
      this.arrows.forEach((btn) => {
        const next = btn.dataset.dir === 'next';
        btn.disabled = next ? left >= max - 1 : left <= 1;
      });
    }
  }
  if (!customElements.get('kw-reviews-slider')) {
    customElements.define('kw-reviews-slider', KwReviewsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
